<template>
  <button
    @click="handleClick"
    :class="[$style.button, { [$style.newMessage]: newMessage }]"
    title="Live coach"
    v-tippy><font-awesome-icon :icon="faBolt" /></button>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faBolt } from '@fortawesome/pro-light-svg-icons/faBolt'
  import { createNamespacedHelpers } from 'vuex'

  const { mapState, mapGetters, mapActions } = createNamespacedHelpers('conference')

  export default {
    components: {
      FontAwesomeIcon
    },
    data () {
      return {
        faBolt,
        newMessage: false
      }
    },
    computed: {
      ...mapState([
        'liveCoachChatVisible'
      ]),
      ...mapGetters([
        'numPrivateMessages'
      ])
    },
    watch: {
      numPrivateMessages () {
        if (!this.liveCoachChatVisible) {
          this.newMessage = true
        }
      },
      liveCoachChatVisible (value) {
        if (value === true) {
          this.newMessage = false
        }
      }
    },
    methods: {
      ...mapActions([
        'showLiveCoachChat'
      ]),
      handleClick () {
        this.showLiveCoachChat()
      }
    }
  }
</script>

<style module lang="less" src="./live-coach-chat-button.less"></style>




// WEBPACK FOOTER //
// live-coach-chat-button.vue?44e5d2bf